namespace $.$$ {

	$mol_style_define( $shm_ba_dashboard_indicators, {
		boxSizing: 'border-box',
		width: '2.5rem',
		height: '2.5rem',
		minWidth: '2.5rem',
		minHeight: '2.5rem',
		maxWidth: '2.5rem',
		maxHeight: '2.5rem',
		flex: {
			grow: 0,
			shrink: 0,
			basis: '2.5rem',
		},

		Trigger: {
			width: '2.5rem',
			height: '2.5rem',
			minWidth: '2.5rem',
			minHeight: '2.5rem',
			maxWidth: '2.5rem',
			maxHeight: '2.5rem',
			padding: 0,
			justifyContent: 'center',
			flex: {
				grow: 0,
				shrink: 0,
				basis: '2.5rem',
			},
		},

		Menu_content: {
			flexDirection: 'column',
			minWidth: '15rem',
			padding: '0.5rem',
		},

		Menu_title: {
			font: {
				weight: 'bold',
			},
			padding: '0.5rem',
		},

		Menu_head: {
			align: { items: 'center' },
		},

		All: {
			flex: { grow: 0 },
		},

		Indicators_drop: {
			width: '100%',
		},

		Indicators: {
			width: '100%',
		},

		Indicator_row: {
			width: '100%',
			cursor: 'grab',
		},

		Indicator_drop: {
			width: '100%',
			'@': {
				mol_drop_status: {
					drag: {
						boxShadow: `inset 0 2px 0 0 ${ $mol_theme.focus }`,
					},
				},
			},
		},

		Indicator_content: {
			width: '100%',
			align: { items: 'center' },
		},

		Indicator_drag_icon: {
			color: $mol_theme.shade,
			margin: { left: $mol_gap.text },
		},

		Indicator: {
			justifyContent: 'flex-start',
			width: '100%',
		},
	} )

}
